/**
 * @ External Dependecies
 */
import styled from 'styled-components';

export default styled.div`
  position: relative;
`;
